/**
 * Default proxy function to convert Vuetify options to API parameters.
 * Can be overridden by the consumer via prop.
 *
 * @param {Object} options - The Vuetify data-table options.
 * @param {number} options.page - Current page number (1-based).
 * @param {number} options.itemsPerPage - Number of items per page.
 * @param {Array} options.sortBy - Array of sort objects [{ key, order }].
 * @param {Array} options.groupBy - Array of group objects.
 * @param {string} options.search - Search string.
 * @returns {Object} API parameters object.
 */
export const defaultOptionsToApiParams = (options) => {
  const { page = 1, itemsPerPage = 10, sortBy = [], groupBy = [], search = '' } = options

  // Vuetify's SortItem.order is optional and may be a boolean, so guard
  // against emitting "key:undefined" / "key:true" — only keep entries
  // with a real direction, mapping a bare `true` to ascending.
  const formatSortItem = ({ key, order }) => {
    if (!order) return null
    return `${key}:${typeof order === 'boolean' ? 'asc' : order}`
  }

  const sort = sortBy.map(formatSortItem).filter(Boolean).join(',')

  const group = groupBy.map(formatSortItem).filter(Boolean).join(',')

  return {
    pagination: {
      page_index: page,
      page_size: itemsPerPage === -1 ? 0 : itemsPerPage,
    },
    sort,
    group,
    search,
  }
}

/**
 * Helper to normalize API response (optional usage)
 * @param {Object} response - The raw API response
 * @returns {Object} { items: Array, total: Number }
 */
export const defaultApiResponseToVuetify = (response) => {
  return {
    items: response.data || [],
    total: response.total || 0,
  }
}
